
// Configuration constants
export const VENDOR_REP_CONFIG_CONSTANTS = {
  HEADERS: {
    SELECT: '',
    EMPLOYEE_ID: 'Employee ID',
    EMPLOYEE_NAME: 'Employee Name',
    VENDOR_NAME: 'Vendor Name',
    YEAR: 'Year',
    QUARTER: 'Quarter',
    QUARTER_YEAR: 'Quarter',
    BEHAVIOURAL_RATING: 'Behavioural Rating',
    TECHINCAL_RATING: 'Technical Rating',
    PERFORMANCE_RATING: 'Performance Rating',
    COMMENTS: 'Comments'
  },
  FIELDS: {
    SELECT: 'select',
    EMPLOYEE_ID: 'employeeId',
    EMPLOYEE_NAME: 'employeeName',
    VENDOR_NAME: 'vendorName',
    VENDOR_ID: 'vendorId',
    YEAR: 'year',
    QUARTER: 'quarter',
    QUARTER_YEAR: 'quarterYear',
    BEHAVIOURAL_RATING: 'behaviouralRating',
    TECHINCAL_RATING: 'techincalRating',
    PERFORMANCE_RATING: 'performanceRating',
    COMMENTS: 'comments'
  },
  CELL_TEMPLATES: {
    CUSTOM_SELECT_COLUMN: 'customSelectColumn',
    CUSTOM_STATUS_COLUMN: 'customStatusColumn',
    CUSTOM_QUARTER_YEAR_COLUMN: 'customQuarterYearColumn'
  }
} as const;

// Reusable configuration objects
const FILTER_CONFIG = { hideMenu: true };
const SORT_ENABLED_CONFIG = { enabled: true };
const SORT_DISABLED_CONFIG = { enabled: false };
const SORT_WITH_COMPARATOR_CONFIG = { enabled: true, comparator: (a: any, b: any) => a.localeCompare(b) };


export const columnDefs = [
  { 
    field: VENDOR_REP_CONFIG_CONSTANTS.FIELDS.SELECT, 
    dataType: VENDOR_REP_CONFIG_CONSTANTS.FIELDS.SELECT,
    headerName: VENDOR_REP_CONFIG_CONSTANTS.HEADERS.SELECT,
    headerCheckboxSelection: false,
    checkboxSelection: false,
    customCellTemplate: VENDOR_REP_CONFIG_CONSTANTS.CELL_TEMPLATES.CUSTOM_SELECT_COLUMN,
  },

  {
    field: VENDOR_REP_CONFIG_CONSTANTS.FIELDS.EMPLOYEE_NAME,
    headerName: VENDOR_REP_CONFIG_CONSTANTS.HEADERS.EMPLOYEE_NAME,
    filterParams: FILTER_CONFIG,
    sortParams: SORT_WITH_COMPARATOR_CONFIG,
  },
  {
    field: VENDOR_REP_CONFIG_CONSTANTS.FIELDS.QUARTER_YEAR,
    headerName: VENDOR_REP_CONFIG_CONSTANTS.HEADERS.QUARTER_YEAR,
    filterParams: FILTER_CONFIG,
    sortParams: SORT_WITH_COMPARATOR_CONFIG,
    customCellTemplate: VENDOR_REP_CONFIG_CONSTANTS.CELL_TEMPLATES.CUSTOM_QUARTER_YEAR_COLUMN,
  },
  {
    field: VENDOR_REP_CONFIG_CONSTANTS.FIELDS.PERFORMANCE_RATING,
    headerName: VENDOR_REP_CONFIG_CONSTANTS.HEADERS.PERFORMANCE_RATING,
    filterParams: FILTER_CONFIG,
    sortParams: SORT_ENABLED_CONFIG,
  },
  {
    field: VENDOR_REP_CONFIG_CONSTANTS.FIELDS.COMMENTS,
    headerName: VENDOR_REP_CONFIG_CONSTANTS.HEADERS.COMMENTS,
    filterParams: FILTER_CONFIG,
    sortParams: SORT_DISABLED_CONFIG,
  },
];